<template>
  <qx-card title="业务流水">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl="accountBO.ajax?cmd=queryAccountDetailsWeb"
          :params="fullSearchData"
          bizName="业务流水记录导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  accountRecord, // 列表
} from 'api/user';
import ExportBtn from 'components/exportBtn';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'createTime',
            label: '操作时间',
          },
          {
            prop: 'teamName',
            label: '来源方',
          },
          {
            prop: 'businessTypesName',
            label: '业务类型',
          },
          {
            prop: 'orderId',
            label: '订单号',
          },
          {
            prop: 'amountDouble',
            label: '金额',
          },
          {
            prop: 'subjectsName',
            label: '备注',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: accountRecord,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
